module.exports = __webpack_public_path__ + "static/media/hyderabad.36cb34dd.svg";